module.exports = __webpack_public_path__ + "static/media/back-ground0.aa22cf09.jpeg";